// Paths that public/robots.txt keeps away from crawlers and that public pages link to.
export const ROBOTS_BLOCKED_PATH = /^\/(?:(?:search|login|register)(?:[/?#]|$)|(?:jobs|auth)\/)/;

export const isRobotsBlockedPath = (to: string): boolean => ROBOTS_BLOCKED_PATH.test(to);
